import React, {Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import HeaderEjercicios from '../../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../../Escritorio/Instrucciones';
import useConfigAuth from '../../../../../Hooks/useConfigAuth';

import { finalizarEjercicioAction, setearEjercicioAction, setearUrlAnteriorAction } from '../../../../../actions/estadoEjercicioActions';
import { almacenarAction } from '../../../../../actions/almacenarEjercicioActions';

import { Flex, FlexFull, ImgB10, AvanzarImg, AvanzarBtn, InputM68, P, BtnNumberM9, CirculoConLineas, NumCalculoM83, ArrowBox, Arrow } from '../../../../Css/StyledMatematica' ;
import { BtnBottom } from '../../../../Css/MetodosCSS/StyledLetras';
import { Img } from '../../../../Css/StyledActivities';

const instrucciones = '';

const M120 = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [config] = useConfigAuth();

    const [count, setCount] = useState(1);
    const [disable, setDisable] = useState(false);
    const [numero1, setNumero1] = useState('');
    const [numero2, setNumero2] = useState('');
    const [numero3, setNumero3] = useState('');
    const [numero4, setNumero4] = useState('');
    const [numero5, setNumero5] = useState('');
    const [numero6, setNumero6] = useState('');
    const [isIncorrect, setIsIncorrect] = useState(false);
    const [isCorrect, setIsCorrect] = useState(false);

    const iniciar = useSelector(state => state.ejercicio.iniciar);
    const finalizar = useSelector(state => state.ejercicio.finalizar);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);
    const sesion = useSelector((state) => state.ejercicio.sesion);

    const GoodWork = () => new Audio('/sounds/sonido_bien.mp3').play();
    const TryAgain = () => new Audio('/sounds/sonidoMal.mp3').play();

    const moverse = (e,nro) => {
        e.preventDefault();
        if(nro === 1) {
            if(count === 18) {
                    setCount(count+1);
                    setNumero1('');
                    setNumero2('');
                    setNumero3('');
            } else {
                setCount(count+1);
            }
        } else {
            if(count == 19) {
                setCount(count-5);
            } else if(count == 14) {
                setCount(count-2);
                setNumero1('');
                setNumero2('');
                setNumero3('');
            } else {
            setCount(count-1);
            }
        }
    }

    const verificar = (e, dato) => {
        e.preventDefault();
        if(count === 13) {
            if(dato === "repartir") {
                setDisable(true);
                setIsCorrect(true);
                GoodWork();
                setTimeout(() => {
                    setDisable(false);
                    setIsCorrect(false);
                    setCount(count + 1);
                }, 300);
            } else {
                setDisable(true);
                setIsIncorrect(true);
                TryAgain();
                setTimeout(() => {
                    setIsIncorrect(false);
                    setDisable(false);
                    return;
                }, 300);
            }
        } else if(count === 14){
            if(numero1 == 6){
                setDisable(true);
                setIsCorrect(true);
                GoodWork();
                setTimeout(() => {
                    setDisable(false);
                    setIsCorrect(false);
                    setCount(count + 1);
                }, 300);
            } else {
                setDisable(true);
                setIsIncorrect(true);
                TryAgain();
                setTimeout(() => {
                    setIsIncorrect(false);
                    setDisable(false);
                    setNumero1('');
                    return;
                }, 300);
            }
        } else if(count === 15){
            if(numero2 == 3){
                setDisable(true);
                setIsCorrect(true);
                GoodWork();
                setTimeout(() => {
                    setDisable(false);
                    setIsCorrect(false);
                    setCount(count + 1);
                }, 300);
            } else {
                setDisable(true);
                setIsIncorrect(true);
                TryAgain();
                setTimeout(() => {
                    setIsIncorrect(false);
                    setDisable(false);
                    setNumero2('');
                    return;
                }, 300);
            }
        } else if(count === 16){
            if(numero3 == 2){
                setDisable(true);
                setIsCorrect(true);
                GoodWork();
                setTimeout(() => {
                    setDisable(false);
                    setIsCorrect(false);
                    setCount(count + 1);
                }, 300);
            } else {
                setDisable(true);
                setIsIncorrect(true);
                TryAgain();
                setTimeout(() => {
                    setIsIncorrect(false);
                    setDisable(false);
                    setNumero3('');
                    return;
                }, 300);
            }
        } else if(count === 21){
            if(numero1 == 6){
                setDisable(true);
                setIsCorrect(true);
                GoodWork();
                setTimeout(() => {
                    setDisable(false);
                    setIsCorrect(false);
                    setCount(count + 1);
                }, 300);
            } else {
                setDisable(true);
                setIsIncorrect(true);
                TryAgain();
                setTimeout(() => {
                    setIsIncorrect(false);
                    setDisable(false);
                    setNumero1('');
                    return;
                }, 300);
            }
        } else if(count === 22){
            if(numero2 == 3){
                setDisable(true);
                setIsCorrect(true);
                GoodWork();
                setTimeout(() => {
                    setDisable(false);
                    setIsCorrect(false);
                    setCount(count + 1);
                }, 300);
            } else {
                setDisable(true);
                setIsIncorrect(true);
                TryAgain();
                setTimeout(() => {
                    setIsIncorrect(false);
                    setDisable(false);
                    setNumero2('');
                    return;
                }, 300);
            }
        } else if(count === 23){
            if(numero3 == 2){
                setDisable(true);
                setIsCorrect(true);
                GoodWork();
                setTimeout(() => {
                    setDisable(false);
                    setIsCorrect(false);
                    setCount(count + 1);
                }, 300);
            } else {
                setDisable(true);
                setIsIncorrect(true);
                TryAgain();
                setTimeout(() => {
                    setIsIncorrect(false);
                    setDisable(false);
                    setNumero3('');
                    return;
                }, 300);
            }
        }
        
    }

    useEffect(() => {
        dispatch(setearEjercicioAction('M120') );
        dispatch(setearUrlAnteriorAction('matematica/calculo/division/'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    useEffect(() => {
        if (count != 24) {
            return;
        } else {
            dispatch(finalizarEjercicioAction());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [count])

    useEffect(() => {
        if(!finalizar) {
            return;
        }
        const informacion = {
            config,
            payload: {
            'ejercicio': 'M120',
            'id_paciente': id_paciente,
            sesion
            }
        }
        dispatch( almacenarAction(informacion) );
        navigate("/escritorio/metodos/finalizar-ejercicio");
    }, [finalizar])

    return (
        <Fragment>
            <HeaderEjercicios estrellas={true} carrito={true} minMay={false} />
            {iniciar
                ?
                <Flex direction="column" height="100%" width="100%" align="center">
                    {count === 1 ?
                        <Flex direction="column" justify="center" margin="auto" width="100%" align='center'>   
                            <FlexFull justify="space-between" align="center" margin="auto">
                                <FlexFull>
                                    <P>
                                        TENGO 6
                                    </P>
                                </FlexFull>
                                <FlexFull direction="column" justify="space-between" align="center" margin="0 2rem 0 2rem">
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" />
                                </FlexFull>
                                <FlexFull>
                                    <P>
                                        PARA REPARTIR ENTRE 3
                                    </P>
                                </FlexFull>
                                <FlexFull direction="column" justify="space-between" align="center" margin="0 1rem 0 1rem">
                                    <ImgB10 src={`/img/nena.png`} w="8rem" wd="8rem" wlg="8rem" />
                                </FlexFull>
                            </FlexFull>
                            <FlexFull justify="space-between" align="center" margin="6rem 0 0 0rem">
                                <FlexFull>
                                    <P>
                                        ¿ME AYUDAS A REPARTIRLOS?
                                    </P>
                                </FlexFull>
                            </FlexFull>
                        </Flex>
                    : count >= 2 && count <=12 ?
                        <Flex margin="auto" width="100%" align='center'
                        isCorrect={isCorrect}
                        isIncorrect={isIncorrect}
                        >   
                            <FlexFull direction="column" justify="space-between" align="center" margin="0 0 1rem 0">
                                <FlexFull  justify="space-between" align="center" margin="0 0 1rem 0">
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 2rem 0 0" />
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 2rem 0 0" />
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 2rem 0 0" />
                                </FlexFull>
                                <FlexFull justify="space-between" align="center" margin="0 0 1rem 0">
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 2rem 0 0" />
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 2rem 0 0" />
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 2rem 0 0" />
                                </FlexFull>
                            </FlexFull>
                            <FlexFull direction="column" justify="center" align="center" margin="0 0 0rem 0">
                                {count >= 3 && count <=12 ? 
                                <ArrowBox size={99}>
                                    <Arrow
                                    angle={-45}
                                    />
                                </ArrowBox>
                                : null }
                                {count >= 3 && count <=12 ? 
                                <ArrowBox size={99}>      
                                    <Arrow
                                    angle={0}
                                    />
                                </ArrowBox>
                                : null }
                                {count >= 3 && count <=12 ? 
                                <ArrowBox size={99}>
                                    <Arrow
                                    angle={45}
                                    />
                                </ArrowBox>
                                : null }
                            </FlexFull>
                            <FlexFull direction="column" justify="space-between" align="center" margin="0 0 1rem 0">
                                <FlexFull justify="space-between" align="center" margin="0 0 1rem 0">
                                    {count >= 4 && count <=12 ? 
                                    <ImgB10 src={`/img/nena.png`} w="8rem" wd="8rem" wlg="8rem" m="0 3rem 0 0" />
                                    : null }
                                    {count >= 7 && count <=12 ? 
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                    : null }
                                    {count >= 10 && count <=12 ? 
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" />
                                    : null }
                                </FlexFull>
                                <FlexFull justify="space-between" align="center" margin="0 0 1rem 0">
                                    {count >= 5 && count <=12 ? 
                                    <ImgB10 src={`/img/nena.png`} w="8rem" wd="8rem" wlg="8rem" m="0 3rem 0 0" />
                                    : null }
                                    {count >= 8 && count <=12 ? 
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                    : null }
                                    {count >= 11 && count <=12 ? 
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" />
                                    : null }
                                </FlexFull>
                                <FlexFull justify="space-between" align="center" margin="0 0 1rem 0">
                                    {count >= 6 && count <=12 ? 
                                    <ImgB10 src={`/img/nena.png`} w="8rem" wd="8rem" wlg="8rem" m="0 3rem 0 0" />
                                    : null }
                                    {count >= 9 && count <=12 ? 
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                    : null }
                                    {count >= 12 ? 
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" />
                                    : null }
                                </FlexFull>
                            </FlexFull>
                        </Flex>
                    : count == 13 ?
                        <Flex margin="auto" width="100%" align='center' direction="column"
                            isCorrect={isCorrect}
                            isIncorrect={isIncorrect}
                            >   
                            <FlexFull justify="space-between" align="center" margin="0 0 1rem 0">
                                <FlexFull  justify="space-between" align="center" margin="0 2rem 0rem 0">
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem0 0" />
                                </FlexFull>
                                <FlexFull justify="space-between" align="center" margin="0 2rem 0rem 0">
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                </FlexFull>
                                <FlexFull justify="space-between" align="center" margin="0 2rem 0rem 0">
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                </FlexFull>
                            </FlexFull>
                            <FlexFull justify="center" align="center">
                                <P fs="3rem" >
                                    ¿QUÉ TUVE QUE HACER?
                                </P>
                            </FlexFull>
                            <FlexFull justify="space-between" align="center">
                                <BtnNumberM9 style={{fontSize: "2.3rem", width: "21vw", height: "16vh"}}
                                    disabled={disable}
                                    onClick={(e) => verificar(e, "juntar")}
                                >
                                    JUNTAR
                                </BtnNumberM9>
                                <BtnNumberM9 style={{fontSize: "2.3rem", width: "21vw", height: "16vh"}}
                                    disabled={disable}
                                    onClick={(e) => verificar(e, "repartir")}
                                >
                                    REPARTIR
                                </BtnNumberM9>
                            </FlexFull>
                        </Flex>
                    : count >= 14 && count <= 18 ?
                        <Flex margin="auto" width="100%" align='center' direction="column"
                            isCorrect={isCorrect}
                            isIncorrect={isIncorrect}
                            >
                            <FlexFull justify="center" align="center" margin="0 0 1rem 0">
                                <FlexFull direction="column" justify="center" align="center" margin="0 0 1rem 0">
                                    <FlexFull  justify="space-between" align="center" margin="0 0rem 1.5rem 1.5rem">
                                        <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                        <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                        <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                    </FlexFull>
                                    <FlexFull justify="space-between" align="center" margin="0 0rem 0rem 0">
                                        <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                        <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                        <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                    </FlexFull>
                                    <FlexFull justify="center" align="center">
                                        <P fs="1rem" >
                                            ¿CUÁNTOS HELADOS <br /> TENEMOS?
                                        </P>
                                    </FlexFull>
                                    <FlexFull>
                                        <InputM68 type="numeric" min="1" max="10" value={numero1} onChange={(e) => setNumero1(e.target.value)} disabled={count != 14 ? true : disable} color='#FF9B2A' bgcolor={count >= 14 ? '#F1F0F0' : '#23AAAF'} bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                    </FlexFull>
                                </FlexFull>
                                <FlexFull direction="column" justify="center" align="center" margin="0 0 1rem 0">
                                    <FlexFull  justify="space-between" align="center" margin="0 0rem 2.5rem 0rem">
                                        <ImgB10 src={`/img/nena.png`} w="8rem" wd="8rem" wlg="8rem" m="0 0 0 0" />
                                        <ImgB10 src={`/img/nena.png`} w="8rem" wd="8rem" wlg="8rem" m="0 0 0 0" />
                                        <ImgB10 src={`/img/nena.png`} w="8rem" wd="8rem" wlg="8rem" m="0 0 0 0" />
                                    </FlexFull>
                                    <FlexFull justify="center" align="center">
                                        <P fs="1rem" >
                                            ¿ENTRE CUÁNTAS <br /> AMIGAS TENEMOS QUE <br /> REPARTIRLOS?
                                        </P>
                                    </FlexFull>
                                    <FlexFull margin="2rem 0 0 0">
                                        <InputM68 type="numeric" min="1" max="10" value={numero2} onChange={(e) => setNumero2(e.target.value)} disabled={count != 15 ? true : disable} color='#FF9B2A' bgcolor={count >= 15 ? '#F1F0F0' : '#23AAAF'} bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                    </FlexFull>
                                </FlexFull>
                                <FlexFull direction="column" justify="center" align="center" margin="0 0 1rem 0">
                                    <FlexFull  justify="space-between" align="center" margin="0 0rem 1.5rem 1.5rem">
                                        <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                        <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem0 0" />
                                    </FlexFull>
                                    <FlexFull justify="center" align="center">
                                        <P fs="1rem" >
                                            ¿CUÁNTOS HELADOS LE <br /> DIMOS A CADA UNA?
                                        </P>
                                    </FlexFull>
                                    <FlexFull margin="5.5rem 0 0 0">
                                        <InputM68 type="numeric" min="1" max="10" value={numero3} onChange={(e) => setNumero3(e.target.value)} disabled={count != 16 ? true : disable} color='#FF9B2A' bgcolor={count >= 16 ? '#F1F0F0' : '#23AAAF'} bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                    </FlexFull>
                                </FlexFull>
                            </FlexFull>
                            <FlexFull justify="center" align="center" margin="0 0 1rem 0">
                                {count >= 17 ?
                                <FlexFull justify="center" align="center">
                                    <P fs="1.2rem" >
                                        CUANDRO REPARTIMOS... ¿QUÉ OPERACIÓN HACEMOS?
                                    </P>
                                </FlexFull>
                                : null }
                                {count == 18 ?
                                <FlexFull justify="center" align="center" color="#23AAAF" fontcolor="#ffffff" bradius="12px" boxshadow="0px 4px 10px rgba(0,0,0,0.25)" padding="0.5rem" margin="0 0 0 0.5rem">
                                    <P fs="1.5rem" fw="700">
                                        DIVISIÓN
                                    </P>
                                </FlexFull>
                                : null }
                            </FlexFull>            
                        </Flex>
                    : count == 19 ?
                        <Flex margin="auto" width="100%" align='center'
                            isCorrect={isCorrect}
                            isIncorrect={isIncorrect}
                            >
                            <FlexFull justify="center" align="center" margin="0 1rem 0 0">
                                <P color="646464" fw="700" fs="7rem">
                                    ÷
                                </P>
                            </FlexFull>
                            <FlexFull justify="center" align="center">
                                <ImgB10 src={`/img/arrowRight.png`} h='8rem' />
                                <P fs="3rem" m="0 0 0 1rem">
                                    SIGNO DIVIDO
                                </P>
                            </FlexFull>         
                        </Flex>
                    : count >= 20 ?
                        <Flex margin="auto" width="100%" align='center' direction="column"
                            isCorrect={isCorrect}
                            isIncorrect={isIncorrect}
                            >
                            <FlexFull justify="center" align="center" margin="0 0 5rem 0">
                                <FlexFull  justify="space-between" align="center" margin="0 1.5rem 1.5rem 0rem">
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                    <ImgB10 src={`/img/helado.png`} w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0.5rem 0 0" />
                                </FlexFull>
                                <FlexFull justify="space-between" align="center" margin="0 0rem 0rem 0">
                                    <ImgB10 src={`/img/nena.png`} w="8rem" wd="8rem" wlg="10rem" m="0 0 0 0" />
                                    <ImgB10 src={`/img/nena.png`} w="8rem" wd="8rem" wlg="10rem" m="0 0 0 0" />
                                    <ImgB10 src={`/img/nena.png`} w="8rem" wd="8rem" wlg="10rem" m="0 0 0 0" />
                                </FlexFull>
                            </FlexFull>
                            <FlexFull justify="space-between" align="flex-start" margin="auto">
                                {count >= 21 ? 
                                <FlexFull>
                                    <P>¿QUÉ <br /> REPARTIMOS?</P>
                                </FlexFull>
                                : null}
                                {count >= 21 ? 
                                <FlexFull>
                                    <ImgB10 src={`/img/arrowRight.png`} h='3rem' tr='rotate(180deg)' />
                                </FlexFull>
                                : null}
                                <FlexFull>
                                    <InputM68 type="numeric" min="1" max="10" value={numero1} onChange={(e) => setNumero1(e.target.value)} disabled={count != 21 ? true : disable} color='#FF9B2A' bgcolor={count >= 21 ? '#F1F0F0' : '#23AAAF'} bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                </FlexFull>
                                <FlexFull direction="column" align="center" justify="center" margin="0.5rem 0.5rem 0.5rem">
                                    <P fs="2.5rem" m="0">÷</P>
                                </FlexFull>
                                <FlexFull direction="column" align="center" justify="center" >
                                    <InputM68 type="numeric" min="1" max="10" value={numero2} onChange={(e) => setNumero2(e.target.value)} disabled={count != 22 ? true : disable} color='#FF9B2A' bgcolor={count >= 22 ? '#F1F0F0' : '#23AAAF'} bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                    {count >= 22 ? 
                                    <FlexFull direction="column" align="center" justify="center" height="">
                                        <ImgB10 src={`/img/arrowRight.png`} h='3rem' tr='rotate(90deg)' />
                                        <P>
                                            ¿ENTRE QUIENES <br /> LO REPARTIMOS?
                                        </P>
                                    </FlexFull>
                                    : null}
                                </FlexFull>
                                <FlexFull align="center" justify="center" margin="0.6rem 0.2rem 0.2rem">
                                    <P fs="2rem" m="0">=</P>
                                </FlexFull>
                                <FlexFull align="center" justify="center">
                                    <InputM68 type="numeric" min="1" max="10" value={numero3} onChange={(e) => setNumero3(e.target.value)} disabled={count != 23 ? true : disable} color='#FF9B2A' bgcolor={count >= 23 ? '#F1F0F0' : '#23AAAF'} bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2.5rem", width: "5rem", margin: "0 0.5rem 0 0.5rem"}} />
                                </FlexFull>
                                {count >= 23 ? 
                                <FlexFull align="center" justify="center" height="">
                                    <ImgB10 src={`/img/arrowRight.png`} h='3rem' />
                                    <P>
                                        ¿CUÁNTOS RECIBE <br /> CADA UNO?
                                    </P>
                                </FlexFull>
                                : null}
                            </FlexFull>         
                        </Flex>
                    : null }
                    {count == 13 ? null 
                    : count === 1 ?
                        <Flex margin="0 0rem 0.5rem 0rem" width="90%" justify="end">
                            <BtnBottom
                                onClick={(e) => moverse(e,1)}
                                disabled={disable}
                            >
                                <Img src={`/img/icono_avanzar.png`} alt="" width='3.5rem' height="3rem" />
                            </BtnBottom>
                        </Flex>
                    : count >= 2 && count <= 23 ?
                        <Flex margin="0 0rem 0.5rem 0rem" width="90%" justify="end">
                            <BtnBottom
                                onClick={(e) => moverse(e,-1)}
                                disabled={disable}
                            >
                                <Img src={`/img/icono_retroceder.png`} alt="" width='3.5rem' height="3rem" />
                            </BtnBottom>
                            {count == 14 || count == 15 || count == 16 || count == 21 || count == 22 || count == 23 ? 
                            <AvanzarBtn
                                disabled={disable}
                                onClick={(e) => verificar(e,"ultimo")}
                            >
                                <AvanzarImg src={'/img/play.png'} /> 
                            </AvanzarBtn>
                            :
                            <BtnBottom
                                onClick={(e) => moverse(e,1)}
                                disabled={disable}
                            >
                                <Img src={`/img/icono_avanzar.png`} alt="" width='3.5rem' height="3rem" />
                            </BtnBottom>
                            }
                        </Flex>
                    : null}
                </Flex>
                :
                    <Instrucciones instrucciones={instrucciones} />
            }
        </Fragment>
    );
}
 
export default M120;